import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import ReactGA from 'react-ga';

class Welcome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zip: null,
      validZip: false,
    };
  }

  handleChange = (event) => {
    const validZip = !isNaN(event.target.value);
    this.setState({
      [event.target.name]: event.target.value,
      validZip
    });
  }

  handleClick = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'locate',
      value: parseInt(this.state.zip, 10)
    });
    this.props.fetchWithZip(this.state.zip);
  }

  render() {
    return (
      <div className="Welcome">
        <h2>Sorry, this service is no longer available.</h2>
      </div>
    );
  }
};

        // <form className="zipForm" onSubmit={(event) => {
          // event.preventDefault();
          // event.stopPropagation();
          // this.props.fetchWithZip(this.state.zip);
        // }}>
          // <label htmlFor="zip">Zip Code:</label>
          // <MaskedInput
            // type="tel"
            // id="zip"
            // name="zip"
            // placeholder="12345"
            // onChange={this.handleChange}
            // mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} />
          // <button
            // disabled={!this.state.validZip}
            // onClick={this.handleClick}
            // className="button locate"
            // type="submit">Locate</button>
        // </form>
export default Welcome;




// WEBPACK FOOTER //
// ./src/Welcome.js